export const FormTitle = ({
  title,
  subLabel,
  t,
}: {
  title: string;
  subLabel?: string;
  t: Record<string, string>;
}) => {
  const cleanTitle = title?.split("<div>")[0];
  return (
    <div className="Step__title-container">
      <h2 className="Step__title extra-large">{t[cleanTitle]}</h2>
      {subLabel && <p className="Step__subLabel">{t[subLabel]}</p>}
    </div>
  );
};
